//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import routes from '~/config/routes'
import EventBus from '~/eventBus'

export default {
    name: 'AppDrawer',

    data(){ return {
      drawer: false,
      leftDrawerOpen: false, // this.$q.platform.is.desktop,
      routes,

      defaultIcon: 'all_out'
    }},


    mounted(){
        EventBus.$on('leftMenuClick', () => {
            this.leftDrawerOpen = !this.leftDrawerOpen
        })
    }
}
